import React, { useEffect, useContext, useRef, useState, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ApiService } from "../../Component/services/apiServices";
import { BrowserView, MobileView } from "react-device-detect";
import { Navigation, Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import Header from "../../Component/Header";
import Footer from "../../Component/Footer";
import AccountHeader from "../../Component/Header/account_header";
import { Swiper, SwiperSlide } from 'swiper/react';
import DataContext from "../../Component/context";
import './cateringStyle.css'
import CateringBookingModal from "./Modal/cateringBookingModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import CateringPlansSection from "./cateringPlansSection";
function CateringNew() {
    const navigate = useNavigate();
    const didMountRef = useRef(true)
    const contextValues = useContext(DataContext);
    const swiperModules = useMemo(() => [Autoplay, Pagination, Navigation], []);

    return (
        <>
            <AccountHeader heading="Daadi's Kitchen Catering"></AccountHeader>
            <div className="catering-header">
                <p className="hero-eyebrow">Sydney's Favourite Vegetarian Catering</p>
                <h1>Food cooked with<br /><em>care &amp; tradition</em></h1>
                <p className="hero-sub">From intimate gatherings to grand celebrations — freshly cooked, pure vegetarian, delivered across Sydney.</p>
                <div className="hero-badges">
                    <span className="hero-badge">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 13A6 6 0 1 1 8 2a6 6 0 0 1 0 12z"></path><path d="M10.97 6.47a.75.75 0 0 0-1.07-1.05L7.477 7.837 6.28 6.64a.75.75 0 1 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.07-.019l3-3.25z"></path></svg>
                        Pure Vegetarian
                    </span>
                    <span className="hero-badge">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 13A6 6 0 1 1 8 2a6 6 0 0 1 0 12z"></path><path d="M7.25 4.75a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75H4.5a.75.75 0 0 1 0-1.5H7.25v-3.75z"></path></svg>
                        Freshly Cooked Daily
                    </span>
                    <span className="hero-badge">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.495 31.495 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94z"></path></svg>
                        5 Locations Across Sydney
                    </span>
                </div>
            </div>
            <CateringPlansSection />
            {/* <section className="section-gap-md bg-light">
                <div className="container">
                    <div className="flat-service">
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="box-service">
                                    <div className="icon-box">
                                        <img src="/img/catering.png" alt=""></img>
                                    </div>
                                    <div className="content">
                                        <h2 className="title">Live Catering</h2>
                                        <p className="description">Fresh dishes prepared on-site to deliver authentic flavours and a memorable dining experience.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="box-service">
                                    <div className="icon-box">
                                        <img src="/img/onion.png" alt=""></img>
                                    </div>
                                    <div className="content">
                                        <h2 className="title">No Onion, No Garlic Menu</h2>
                                        <p className="description">Specially crafted pure vegetarian dishes made without onion and garlic, perfect for traditional and dietary preferences.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="box-service">
                                    <div className="icon-box">
                                        <img src="/img/restaurant.png" alt=""></img>
                                    </div>
                                    <div className="content">
                                        <h2 className="title">Customisable Menu</h2>
                                        <p className="description">Choose from a wide range of Indian dishes tailored to your event’s needs.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="box-service">
                                    <div className="icon-box">
                                        <img src="/img/fresh.png" alt=""></img>
                                    </div>
                                    <div className="content">
                                        <h2 className="title">Fresh & Hygienic Preparation</h2>
                                        <p className="description">Every dish is prepared with high-quality ingredients and strict hygiene standards.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrap-counter">
                        <div className="counter-box">
                            <div className="count-number">
                                <div className="number" data-speed="2000" data-to="85" data-inviewport="yes">500+</div>
                            </div>
                            <div className="title-count">Successful Catering Events</div>
                        </div>
                        <div className="counter-box">
                            <div className="count-number">
                                <div className="number" data-speed="2000" data-to="112" data-inviewport="yes">15</div>
                            </div>
                            <div className="title-count">Years of Culinary Experience</div>
                        </div>
                        <div className="counter-box">
                            <div className="count-number">
                                <div className="number" data-speed="2000" data-to="32" data-inviewport="yes">50+</div>
                            </div>
                            <div className="title-count">Authentic Vegetarian Dishes</div>
                        </div>
                        <div className="counter-box">
                            <div className="count-number">
                                <div className="number" data-speed="2000" data-to="66" data-inviewport="yes">100%</div>
                            </div>
                            <div className="title-count">Pure Veg, No Onion & No Garlic Options</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-gap-sm">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <Swiper
                                spaceBetween={15}
                                slidesPerView={1.2}
                                navigation={false}
                                pagination={{ clickable: true }}
                                modules={swiperModules}
                            >
                                <SwiperSlide>
                                    <div className="edu-team-grid edu-team-grid-style-2">
                                        <div className="inner">
                                            <div className="thumbnail-wrap">
                                                <div className="thumbnail">
                                                    <a href="#">
                                                        <img alt="Wedding &amp; Engagement Catering" src="/img/cat05.jpg" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="content">
                                                <h2 className="title"><a href="#">Wedding & Engagement Catering</a></h2>
                                                <p>Celebrate Love with Authentic Indian Flavors. A wedding is a celebration of traditions, joy, and togetherness. At Daadi's Kitchen, we craft authentic vegetarian feasts that honour your special moments, ensuring your guests enjoy a meal that's as memorable as your big day.</p>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="edu-team-grid edu-team-grid-style-2">
                                        <div className="inner">
                                            <div className="thumbnail-wrap">
                                                <div className="thumbnail">
                                                    <a href="#">
                                                        <img alt="Haldi, Mehendi &amp; Sangeet Catering" src="/img/cat04.jpg" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="content">
                                                <h2 className="title"><a href="#">Haldi, Mehendi & Sangeet Catering</a></h2>
                                                <p>Vibrant, Festive, and Flavorful. Pre-wedding celebrations are all about fun, music, and delicious food! Our catering ensures your Haldi, Mehendi, and Sangeet are filled with flavorful delights that keep the energy high.</p>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="edu-team-grid edu-team-grid-style-2">
                                        <div className="inner">
                                            <div className="thumbnail-wrap">
                                                <div className="thumbnail">
                                                    <a href="team-details.html">
                                                        <img alt="Reception Catering" src="/img/cat03.jpg" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="content">
                                                <h2 className="title"><a href="#">Reception Catering</a></h2>
                                                <p>An Elegant Feast to Mark the Beginning of Forever. Receptions call for a grand dining experience. Whether you prefer a traditional sit-down meal or a lively buffet.</p>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="edu-team-grid edu-team-grid-style-2">
                                        <div className="inner">
                                            <div className="thumbnail-wrap">
                                                <div className="thumbnail">
                                                    <a href="team-details.html">
                                                        <img alt="Religious Event Catering" src="/img/cat02.jpg" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="content">
                                                <h2 className="title"><a href="#">Pooja &amp; Religious Event Catering</a></h2>
                                                <p>Pure, Sattvic, and Divine Offerings. For spiritual ceremonies, poojas, havans, and fasting days, we provide pure vegetarian meals prepared with care and devotion.</p>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="edu-team-grid edu-team-grid-style-2">
                                        <div className="inner">
                                            <div className="thumbnail-wrap">
                                                <div className="thumbnail">
                                                    <a href="#">
                                                        <img src="/img/cat01.jpg" alt="team images" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="content">
                                                <h2 className="title"><a href="#">Corporate Catering</a></h2>
                                                <p>Elevate Your Workplace Gatherings with Authentic Indian Cuisine. Impress your team, clients, and colleagues with a curated menu that brings the best of Indian vegetarian cuisine to your business events.</p>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="edu-team-grid edu-team-grid-style-2">
                                        <div className="inner">
                                            <div className="thumbnail-wrap">
                                                <div className="thumbnail">
                                                    <a href="#">
                                                        <img src="/img/cat06.jpg" alt="team images" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="content">
                                                <h2 className="title"><a href="#">Personal & Family Gathering Catering</a></h2>
                                                <p>Home-Style Indian Food for Every Occasion. From birthdays and anniversaries to family get-togethers and special celebrations, let us handle the food while you create beautiful memories.</p>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>
                    </div>
                </div>
            </section> */}
            {contextValues.toggleCateringModal && (<CateringBookingModal />)}
        </>
    )
}

export default CateringNew